<template>
  <v-dialog persistent v-model="selectMissionDialog.status" max-width="500px">
    <v-card>
      <v-img :src="selectMissionDialog.img" class="white--text align-end" gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)" height="200px">
        <v-card-title>Select Mission</v-card-title>
      </v-img>
      <v-divider></v-divider>
      <v-card-text>
        <v-select v-model="selectMissionDialog.mission" :items="selectMissionDialog.mission_name_list" label="Mission" @change="SelectMission"></v-select>
        <v-select v-model="selectMissionDialog.quota" :items="selectMissionDialog.quotas" label="Quota"></v-select>
        <v-text-field v-model="selectMissionDialog.permission_code" label="Custom Permission Token"></v-text-field>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn outlined color="grey" @click="selectMissionDialog.status = false">Cancel</v-btn>
        <v-btn outlined color="primary" @click="CreateMissionRecord">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Cookies from 'js-cookie'
const firebase = require('firebase')
const app = firebase.initializeApp({
  databaseURL: process.env.VUE_APP_FIREBASE_URL
})
const database = firebase.database()
export default {
  name: 'selectMissionDialog',
  data: () => ({
    selectMissionDialog: {}
  }),
  created () {
    this.selectMissionDialog = this.$store.state.selectMissionDialog
    Cookies.get('permissionToken') !== undefined ? this.selectMissionDialog.permission_code = Cookies.get('permissionToken') : this.selectMissionDialog.permission_code = ''
    database.ref('/mission_list').once('value', e => {
      this.$store.commit('setSelectMissionDialogMissions', e.val())
    })
  },
  methods: {
    SelectMission () {
      let result = this.selectMissionDialog.missions.filter(mission => mission.name === this.selectMissionDialog.mission)
      this.selectMissionDialog.img = result[0].img
      this.selectMissionDialog.quotas = [result[0].quota, result[0].quota * 2, result[0].quota * 3, result[0].quota * 4, result[0].quota * 5]
    },
    CreateMissionRecord () {
      let accessToken = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
      let permissionToken = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
      if (this.selectMissionDialog.permission_code !== '') {
        permissionToken = this.selectMissionDialog.permission_code
        Cookies.set('permissionToken', permissionToken, { expires: 7 })
      }
      let data = {
        permission_toekn: permissionToken,
        name: this.selectMissionDialog.mission,
        quota: this.selectMissionDialog.quota,
        img: this.selectMissionDialog.img,
        players: []
      }
      database.ref('/game_record/' + accessToken).set(data).then(() => {
        this.selectMissionDialog.status = false
        this.$store.commit('setSnackBar', {
          icon: 'far fa-check-circle',
          color: 'primary',
          status: true,
          text: 'New Game Record Created',
          timeout: 2000
        })
        this.$store.commit('setAlertBarState', {
          status: true,
          title: 'New Game Record Created',
          group_key: accessToken,
          permission_key: permissionToken
        })
      }
      )
    }
  }
}
</script>

<style scoped>

</style>
